import { faCheckCircle, faClock, faFileInvoice, faXmarkCircle, IconDefinition } from '@fortawesome/pro-light-svg-icons'
import useTwinTranslation from '../useTwinTranslation'
export type ProcessedTypeDict = { title: string, colorText: string }
type ProcessedTypeDictComplete = { title: string, colorText: string, icon: IconDefinition }
const useOrderProcessedTypesDict = () => {
    const { t } = useTwinTranslation()
    const processedTypesDict: { [id: number | string]: ProcessedTypeDictComplete } = {
        1: { title: t('inDeliveryNote', 'En albarán'), colorText: 'text-yellow-B9', icon: faClock },
        2: { title: t('draftInvoiceShort', 'Borrador fact.'), colorText: 'text-yellow-B9', icon: faClock },
        3: { title: t('invoiced', 'Facturado'), colorText: 'text-green-43', icon: faFileInvoice },
        4: { title: t('processed', 'Procesado'), colorText: 'text-green-43', icon: faCheckCircle },
        5: { title: t('canceled', 'Cancelado'), colorText: 'text-red-BA', icon: faXmarkCircle },
        6: { title: t('refunded', 'Devuelto'), colorText: 'text-red-BA', icon: faXmarkCircle },
    }
    return processedTypesDict
}

export default useOrderProcessedTypesDict